"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var utilities_1 = require("../../../../../utilities/utilities");
var utils_1 = require("../../utils");
var TwitterWrapper_1 = tslib_1.__importDefault(require("./TwitterWrapper"));
var TwitterTimeline = function (_a) {
    var _b = _a.config, data_href = _b.data_href, data_height = _b.data_height, data_width = _b.data_width, tweet_limit = _b.tweet_limit, config = _a.config;
    var width = utils_1.getNumber(data_width, void 0);
    var height = utils_1.getNumber(data_height, void 0);
    // 1 < tweetLimit < 20
    var tweetLimit = utils_1.getNumberValueInRange(tweet_limit, void 0, 1, 20);
    return (React.createElement(TwitterWrapper_1["default"], { config: config },
        React.createElement("a", { className: "twitter-timeline", "data-width": width, "data-height": height, "data-tweet-limit": tweetLimit, href: data_href }, utilities_1.__('Twitter časová os'))));
};
exports["default"] = TwitterTimeline;
